// extracted by mini-css-extract-plugin
module.exports = {"container":"Question_container__DtSeW","progress_wrapper":"Question_progress_wrapper__IEvQn","quiz_image_wrapper":"Question_quiz_image_wrapper__1i313"};